module.exports = __webpack_public_path__ + "img/pt_Ecran 4.52dabd1c.png";